/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { MomijiToken } from "../MomijiToken";

export class MomijiToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    tokenName: string,
    tokenSymbol: string,
    baseUri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MomijiToken> {
    return super.deploy(
      tokenName,
      tokenSymbol,
      baseUri,
      overrides || {}
    ) as Promise<MomijiToken>;
  }
  getDeployTransaction(
    tokenName: string,
    tokenSymbol: string,
    baseUri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      tokenName,
      tokenSymbol,
      baseUri,
      overrides || {}
    );
  }
  attach(address: string): MomijiToken {
    return super.attach(address) as MomijiToken;
  }
  connect(signer: Signer): MomijiToken__factory {
    return super.connect(signer) as MomijiToken__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MomijiToken {
    return new Contract(address, _abi, signerOrProvider) as MomijiToken;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "string",
        name: "tokenSymbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Create",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenMaxQuantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenCurrentQuantity",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "creators",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "mintManuallyQuantityWithId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minters",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "onlyWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "tokenBaseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "tokenIdAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenIds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenMaxQuantityWithId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenQuantityWithId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "create",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "addMintManuallyQuantity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "removeMintManuallyQuantity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "openToEveryone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "openOnlyToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "transferCreator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
